import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Tab } from './Tab';
import styles from './Tabs.module.scss';

const Tabs = (props) => {
  const { 
    useSiteAsFilter,
    activeTab,
    setActiveTab,
    children,
    colorScheme
  } = props

  const childrenArray = React.Children.toArray(children);

  useEffect(() => {
    if (useSiteAsFilter === '1') {
      setActiveTab(window.mapiTranslations['Choose Cinema']);
    }
  }, [useSiteAsFilter]);

  const onClickTabItem = (tab) => {
    setActiveTab(tab);
  }

  return (
    <div className="tabs">
      <ol className={styles.tabList}>
        {childrenArray.map((child) => {
          if (!child) {
            return undefined;
          }

          const { label } = child.props;

          return (
            <Tab
              activeTab={activeTab}
              key={label}
              label={label}
              onClick={onClickTabItem}
              colorScheme={colorScheme}
            />
          );
        })}
      </ol>

      <div className={styles.tabContent}>
        {childrenArray.map((child) => {
          if (!child) {
            return undefined;
          }

          if (child.props.label !== activeTab) return undefined;
          return child.props.children;
        })}
      </div>
    </div>
  );
}

Tabs.propTypes = {
  children: PropTypes.node.isRequired,
};

export { Tabs };
